// extracted by mini-css-extract-plugin
module.exports = {"container":"DevTools-module--container--1wdu6","devToolImg":"DevTools-module--devToolImg--1j95u","devTool":"DevTools-module--devTool--3Vxm8","demo":"DevTools-module--demo---mn6_"};